import { CompanyBrandRef, CompanyRef } from '@thehubz/client/data-access-api';

export type CallFromType =
  | 'shareAssets'
  | 'shareCollection'
  | 'shareTask'
  | 'dashboard'
  | 'publishCollection'
  | 'project'
  | 'assetRelations'
  | 'collectonListview';

export interface ProjectDetails {
  project?: { id: string; name: string };
  projectDetails?: {
    agency?: CompanyRef;
    client?: CompanyRef;
    brand?: CompanyBrandRef;
  };
}

interface HideElements {
  hideDelete?: boolean;
  hideDownload?: boolean;
  hideAddToBasket?: boolean;
  hideAddToCollection?: boolean;
  hideSelection?: boolean;
  hideShare?: boolean;
}

export interface ConfigObjectModel extends ProjectDetails, HideElements {
  title: string;
  callFrom: CallFromType;
  cardHeight?: string;
  rowHeight?: string;
  createdBy?: string;
  createdAt?: string;
  text?: string;
  noOfItems?: number;
  itemSize?: number;
  routerLink?: string;
  className?: string;
  branding?: string;
}
